import React from 'react';
import Button from '@sizeid/commons/components/Button';
import { CONTACT_INDEX } from '@sizeid/shared/constants/routes';
import { WithTranslation } from 'next-i18next';

import { CONTACT_PHONE, CONTACT_EMAILS } from 'constants/contact';
import H3 from 'components/typo/Heading/H3';
import ProtectedEmail from 'components/ProtectedEmail';
import RouteLink from 'components/RouteLink';
import { withTranslation } from 'lib/i18n';

import veru from '../../../company/images/people/avatar_Verca.svg';
import andy from '../../../company/images/people/avatar_Andy.svg';

import Wrap from './styled/Wrap';

const OrganizationsContact: React.FC<WithTranslation> = props => (
  <Wrap>
    <div className="addresses">
      <a href={`tel:${CONTACT_PHONE}`} className="number">
        {CONTACT_PHONE}
      </a>
      <ProtectedEmail email={CONTACT_EMAILS.info} />
    </div>
    <div className="people">
      <div>
        <img src={andy} alt="Andrea Sliacka" />
        <H3>Andrea Sliacka</H3>
      </div>
      <div>
        <img src={veru} alt="Veronika Matějková" />
        <H3>Veronika Matějková</H3>
      </div>
    </div>
    <RouteLink
      href={{
        pathname: CONTACT_INDEX.route,
        query: { organizationsDemo: true },
      }}
      passHref
    >
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a>
        <Button giant>
          {props.t('business.organizations.index.contact_me')}
        </Button>
      </a>
    </RouteLink>
  </Wrap>
);

export default withTranslation('pages')(OrganizationsContact);
